module.exports = __webpack_public_path__ + "static/media/05.685f8b4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/south-korea-two/05.jpg
// module id = 526
// module chunks = 0